import { render } from "./WholesaleCustomersListPage.vue?vue&type=template&id=c0eb0db8&ts=true"
import script from "./WholesaleCustomersListPage.vue?vue&type=script&lang=ts"
export * from "./WholesaleCustomersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__